<template>
<div class="chapter">
<div class="inner_page">
<h2 id="toc_marker-5">Introduction</h2>
<p class="veryfirst">The objective of this book is to help the reader to apply Christian thinking to economic issues. Issues addressed range from the most fundamental assumptions underlying modern economics to society’s placid acceptance of the legitimization and growth of immoral and spiritually destructive activities such as pornography.</p>
<p class="body">The book assumes that ethics are inexorably intertwined with economic life and analysis. Ethics, whether transmitted through culture, religion or simply habit, influence the behavior of consumers and producers. Public policies, and their associated objectives, are almost always linked to ethical viewpoints. Lack of ethics such as honesty and trustworthiness can drive transaction costs so high as to choke off exchange and economic growth.</p>
<p class="body">The book is written from the perspective of Christian ethics, Christian standards of behavior as found in Scripture. God makes it quite clear that we are to know his Word and apply it in our lives (Deut 6:5-9). The greatest commandment, Jesus instructs us, is to love the Lord our God with all our heart, soul <i>and mind</i> (Mt 22:36-37). As responsible disciples (<i>disciple</i> means learner), we are to apply our minds to all aspects of life, including the economic. We are to wrestle as Christians with the many economic issues that play such a prominent role in the lives of billions of persons.</p>
<p class="body">The book is arranged in five parts. The first part lays the foundation for the Christian analysis in the remainder of the book through the presentation of a framework of Christian ethics relevant to economics. Part two contains Christian reflections on four of the most basic assumptions of market economics: the importance of self-interest, the goal of economic efficiency, the significance of private property rights and economics as a social science. Parts three, four and five apply the Christian ethical framework to a series of macroeconomic, microeconomic and international issues.</p>
<p class="body">While the book may be read by persons with little background in economics, it is primarily intended to be a supplemental text to students studying introductory economics. The chapter topics were selected after a thorough examination of the leading textbooks used in teaching principles of economics.</p>
<p class="body">Learning the conceptual frameworks of economics is not easy. Applying Christian ethics to these frameworks adds to the workload. Yet it is a challenge we are obligated to undertake if we have chosen to seek first his kingdom. As we toil, let us remember:</p>
<blockquote>
<p class="verse">Instead of destroying the world,</p>
<p class="verseindent">as He did with Noah,</p>
<p class="verse">He destroyed the Old Adam in you.</p>
</blockquote>
<blockquote>
<p class="verse">Instead of drowning a false god,</p>
<p class="verseindent">as He did with Pharaoh,</p>
<p class="verse">He drowned the idolatry within you.</p>
</blockquote>
<blockquote>
<p class="verse">Instead of taking you out of the land of darkness,</p>
<p class="verseindent">as He did for the people of Israel,</p>
<p class="verse">He blotted out the darkness in your own heart</p>
<p class="verseindent">and provides the light,</p>
<p class="verseindent2">the light of the Spirit of God,</p>
<p class="verseindent3">the light of Jesus Christ,</p>
<p class="verseindent4">the light of the world. (Jn 8:12; 9:5)<a id="cue_3048_1"></a><span href="#/Text/notes#note_3048_1" title="Link target outside of Sample"><span class="notesbodyref">1</span></span></p>
</blockquote>
<p class="body"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Introduction.vue?5ed30e6f